<div
    class="cr-document-upload"
    [class.cr-document-upload--required]="showRequiredHighlight"
    [class.cr-document-upload--error]="!!uploadError || missingRequired"
>
    <p
        *ngIf="requiredDocsLabel"
        class="cr-document-upload-label cr-field-docs small mb-2"
        [class.text-muted]="!showRequiredHighlight"
    >
        Required documents<span *ngIf="showRequiredHighlight"> *</span>: {{ requiredDocsLabel }}
    </p>
    <div class="d-flex flex-wrap align-items-center gap-2">
        <button
            type="button"
            class="btn btn-sm cr-document-upload-btn"
            [class.btn-outline-danger]="showRequiredHighlight"
            [class.btn-outline-primary]="!showRequiredHighlight"
            (click)="triggerBrowse()"
            [disabled]="disabled"
        >
            <i class="ri-upload-2-line me-1"></i>
            Upload document(s)
        </button>
        <input
            #fileInput
            type="file"
            class="d-none"
            multiple
            [accept]="acceptTypes"
            (change)="onFileSelected($event)"
        />
    </div>
    <ul *ngIf="files.length" class="cr-document-upload-list list-unstyled small mb-0 mt-2">
        <li
            *ngFor="let f of files; let i = index"
            class="cr-document-upload-item d-flex align-items-center justify-content-between"
        >
            <span class="text-truncate me-2">{{ f.name }}</span>
            <button
                type="button"
                class="btn btn-link btn-sm p-0 text-danger"
                (click)="removeFile(i)"
                [disabled]="disabled"
                title="Remove file"
            >
                <i class="ri-close-line"></i>
            </button>
        </li>
    </ul>
    <div *ngIf="uploadError" class="invalid-feedback d-block mt-1">
        {{ uploadError }}
    </div>
    <div *ngIf="missingRequired" class="invalid-feedback d-block mt-1">
        At least one document is required for the changes above.
    </div>
</div>
